export function getPasswordSegurity(password:string){
    let haveNumber:boolean = false;
    let numbers:string ='0123456789';
    let haveLowercaseLetter:boolean = false;
    let lowercaseLetters:string ='abcdefghyjklmnñopqrstuvwxyz';
    let haveCapitalLetter:boolean = false;
    let CapitalLetters:string = 'ABCDEFGHYJKLMNÑOPQRSTUVWXYZ';
    let haveCharacter:boolean = false;
    for(let index = 0; index < password.length; index++){
        if(numbers.indexOf(password.charAt(index), 0) != -1){haveNumber = true;}
        if(lowercaseLetters.indexOf(password.charAt(index), 0) != -1){haveLowercaseLetter = true;}
        if(CapitalLetters.indexOf(password.charAt(index), 0) != -1){haveCapitalLetter = true;}
        if(numbers.indexOf(password.charAt(index), 0) == -1 && lowercaseLetters.indexOf(password.charAt(index), 0) == -1 && CapitalLetters.indexOf(password.charAt(index), 0) == -1){haveCharacter = true;}
    };
    let count = 0;
    if(haveNumber){ count++; }
    if(haveLowercaseLetter){ count++; }
    if(haveCapitalLetter){ count++; }
    if(haveCharacter){ count++; }
    switch (count) {
        case 1:  return "true||Tu contraseña es poco segura, se recomienda que se cambie lo antes posible. (Ve a 'Configuración')";
        case 2:  return "true||Tu contraseña es considerada poco segura, se recomienda que se actualice. (Ve a 'Configuración')";
        case 3:  return "false||Tu contraseña es considerada buena.";
        case 4:  return "false||Tu contraseña es considerada segura.";
        default: return "true||Tu contraseña es poco segura, se recomienda que se cambie lo antes posible.";
    }
}

export function downloadFile (data,name){
    var fileURL = window.URL.createObjectURL(new Blob([data], {type:'application/*'}));
    var fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', name);
    document.body.appendChild(fileLink);

    fileLink.click();
}

export function getConfigureUnitType(){
    return [
        {unit_type_id: 1, type: 'motor'},
        {unit_type_id: 2, type: 'drag'},
        {unit_type_id: 3, type: 'drag'},
        {unit_type_id: 4, type: 'drag'},
        {unit_type_id: 5, type: 'drag'},
        {unit_type_id: 6, type: 'drag'},
        {unit_type_id: 7, type: 'drag'},
        {unit_type_id: 8, type: 'motor'},
        {unit_type_id: 9, type: 'motor'},
        {unit_type_id: 10, type: 'motor'},
        {unit_type_id: 11, type: 'drag'},
        {unit_type_id: 12, type: 'motor'},
    ];
}

export function getUtilitarianColumns(){
    return [
        {
            id: 1,
            text_th: 'Datos de Circulación',
            cols: '4',
            type: 'utilitarian',
            columns:[
                { name: 'No. Factura', value1: 'title', type: 'text' },
                { name: 'No. Tarjeta de Circulación', value1: 'identifier', type: 'text' },
                { name: 'Fecha', value1: 'initial_date', isDate: true, type: 'date' },
                { name: 'Costo sin Iva', value1: 'price', isMoney: true, type: 'number' },
            ],
        },
        {
            id: 2,
            text_th: 'Datos de Verificación',
            cols: '4',
            type: 'utilitarian',
            columns:[
                { name: 'No. Verificación', value1: 'identifier', type: 'text' },
                { name: 'Fecha de Verificación', value1: 'initial_date', isDate: true, type: 'date' },
                { name: 'Costo de Verificación', value1: 'price', isMoney: true, type: 'number' },
                { name: 'Multa', value1: 'extra_cost', isMoney: true, type: 'number', isEdit: true },
            ],
        },
        {
            id: 3,
            text_th: 'Póliza de Seguro',
            cols: '5',
            type: 'utilitarian',
            columns:[
                { name: 'No. Póliza de Seguro', value1: 'identifier', type: 'text' },
                { name: 'Fecha de Vencimiento', value1: 'final_date', isDate: true, type: 'date' },
                { name: 'Costo de la Poliza de Seguro', value1: 'price', isMoney: true, type: 'number' },
                { name: 'Multa', value1: 'extra_cost', isMoney: true, type: 'number', isEdit: true },
                { name: 'Días de Notificación', value1: 'notification_days', type: 'number' },
            ],
        },
        {
            id: 4,
            text_th: 'Datos de Servicio',
            cols: '10',
            type: 'utilitarian',
            columns:[
                { name: 'Km. Inicial de Servicio', value1: 'initial_kms', type: 'number' },
                { name: 'Km. Final de Servicio', value1: 'final_kms', type: 'number' },
                { name: 'Total de Km', value1: 'initial_kms', value2: 'final_kms', isTotal: true, isQuantity: true, sign: -1 },
                { name: 'Factura de Servicio', value1: 'identifier', type: 'text' },
                { name: 'Costo de Servicio', value1: 'price', isMoney: true, type: 'number' },
                { name: 'Fecha de Verificación', value1: 'initial_date', isDate: true, type: 'date' },
                { name: 'Fecha de Vencimiento de Verificación', value1: 'final_date', isDate: true, type: 'date' },
                { name: 'Costo de Verificación', value1: 'iva', isMoney: true, type: 'number' },
                { name: 'Costo Multa', value1: 'extra_cost', isMoney: true, type: 'number', isEdit: true },
                { name: 'Días de Notificación', value1: 'notification_days', type: 'number' },
            ],
        },
        {
            id: 5,
            text_th: 'Datos de Tenencia',
            cols: '4',
            type: 'utilitarian',
            columns:[
                { name: 'Fecha de Pago de Tenencia', value1: 'initial_date', isDate: true, type: 'date' },
                { name: 'Fecha de Vencimiento de Tenencia', value1: 'final_date', isDate: true, type: 'date' },
                { name: 'Costo de Tenencia', value1: 'price', isMoney: true, type: 'number' },
                { name: 'Días de Notificación', value1: 'notification_days', type: 'number' },
            ],
        },
        {
            id: 6,
            text_th: 'Contaminantes',
            cols: '6',
            type: 'motor',
            columns:[
                { name: 'PERIODO', value1: 'title', type: 'text' },
                { name: 'FECHA DE VERIFICACIÓN', value1: 'initial_date', isDate: true, type: 'date' },
                { name: 'FECHA DE VENCIMIENTO', value1: 'final_date', isDate: true, type: 'date' },
                { name: 'QUIEN RECIBE PAPELETA COTEJADA', value1: 'identifier', type: 'text' },
                { name: 'COSTO', value1: 'price', isMoney: true, type: 'number' },
                { name: 'Días de Notificación', value1: 'notification_days', type: 'number' },
            ],
        },
        {
            id: 6,
            text_th: 'Contaminantes',
            cols: '6',
            type: 'drag',
            columns:[
                { name: 'PERIODO', value1: 'title', type: 'text' },
                { name: 'FECHA DE VERIFICACIÓN', value1: 'initial_date', isDate: true, type: 'date' },
                { name: 'FECHA DE VENCIMIENTO', value1: 'final_date', isDate: true, type: 'date' },
                { name: 'QUIEN RECIBE PAPELETA COTEJADA', value1: 'identifier', type: 'text' },
                { name: 'COSTO', value1: 'price', isMoney: true, type: 'number' },
                { name: 'Días de Notificación', value1: 'notification_days', type: 'number' },
            ],
        },
        {
            id: 7,
            text_th: 'Físico-Mecánica',
            cols: '6',
            type: 'motor',
            columns:[
                { name: 'PERIODO', value1: 'title', type: 'text' },
                { name: 'FECHA DE VERIFICACIÓN', value1: 'initial_date', isDate: true, type: 'date' },
                { name: 'FECHA DE VENCIMIENTO', value1: 'final_date', isDate: true, type: 'date' },
                { name: 'QUIEN RECIBE PAPELETA COTEJADA', value1: 'identifier', type: 'text' },
                { name: 'COSTO', value1: 'price', isMoney: true, type: 'number' },
                { name: 'Días de Notificación', value1: 'notification_days', type: 'number' },
            ],
        },
        {
            id: 7,
            text_th: 'Físico-Mecánica',
            cols: '6',
            type: 'drag',
            columns:[
                { name: 'PERIODO', value1: 'title', type: 'text' },
                { name: 'FECHA DE VERIFICACIÓN', value1: 'initial_date', isDate: true, type: 'date' },
                { name: 'FECHA DE VENCIMIENTO', value1: 'final_date', isDate: true, type: 'date' },
                { name: 'QUIEN RECIBE PAPELETA COTEJADA', value1: 'identifier', type: 'text' },
                { name: 'COSTO', value1: 'price', isMoney: true, type: 'number' },
                { name: 'Días de Notificación', value1: 'notification_days', type: 'number' },
            ],
        },
    ];
}